import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ORGANIZATIONS_KEY } from '_api/queries/organizations/useGetAllOrganizations';
import { GET_ORGANIZATION_BY_ID_KEY } from '_api/queries/organizations/useGetOrganizationsByID';
import { Organization, OrganizationPayload } from '_api/types';

export const UPDATE_ORGANIZATION_KEY = 'update-organization';

export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Organization, OrganizationPayload>(
    () => '/organization',
    'put',
    {},
    {
      mutationKey: [UPDATE_ORGANIZATION_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ORGANIZATION_BY_ID_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ORGANIZATIONS_KEY] });
      },
    },
    (body: OrganizationPayload) => body,
  );
};
